
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkDocumentSyncSettingsDto } from '../models/work-document-sync-settings-dto';

export function getTenantProjectLinkSyncSettingsDtoFormGroup() {
return new FormGroup({
    standardtaskMappings: new FormControl<any | undefined>(undefined),
    documentTypeMappings: new FormControl<any | undefined>(undefined),
    documentSubtypeMappings: new FormControl<any | undefined>(undefined),
    matchingStrategy: new FormControl<string | undefined>('all'),
    documentSyncSettings: new FormControl<WorkDocumentSyncSettingsDto | undefined>(undefined),
})
;
}
      